import { InfoIcon } from '@phosphor-icons/react'
import { ScoopTooltip } from '../ScoopTooltip/ScoopTooltip'
import styles from './ScoopInfoTooltip.module.scss'

/**
 * ScoopInfoTooltip - Info icon with tooltip
 *
 * @param {Object} props - Component props
 * @param {string|React.ReactNode} props.title - Tooltip content
 * @param {string} [props.placement='top'] - Tooltip placement (top, bottom, left, right, etc.)
 * @param {number} [props.size=14] - Icon size in pixels
 * @param {string} [props.weight='bold'] - Icon weight (regular, bold, etc.)
 * @param {string} [props.className] - Additional CSS classes for icon wrapper
 */
export const ScoopInfoTooltip = ({
    title,
    placement = 'top',
    size = 14,
    weight = 'bold',
    className = '',
}) => {
    const wrapperClassName = [styles.iconWrapper, className].filter(Boolean).join(' ')

    return (
        <ScoopTooltip title={title} placement={placement}>
            <span className={wrapperClassName}>
                <InfoIcon size={size} weight={weight} className={styles.icon} />
            </span>
        </ScoopTooltip>
    )
}

ScoopInfoTooltip.displayName = 'ScoopInfoTooltip'
